export const HH_LOGIN_LINK = `https://hh.ru/account/login`;
export const CLICKME_LINK_PROMO = 'https://hh.ru/article/clickme';
export const CAMPAIGN_CREATE_URL = '/new/campaign/create/';
export const CAMPAIGN_QUICK_CREATE_URL = '/new/campaign/quick/create/';
// exp_PORTFOLIO-58018_next_line
export const CAMPAIGN_VR_CREATE_URL = '/new/campaign/vr/create/';
export const AUCTION_PAGE_ROUTE = '/new/campaign/auction/vacancy/:vacancyId';
export const CREATE_MENU_PAGE_ROUTE = '/new/create/menu/';
export const DASHBOARD_PAGE_ROUTE = '/new/dashboard/';
export const CAMPAIGNS_DASHBOARD_PAGE_ROUTE = '/new/campaigns/';
export const SUBSCRIPTIONS_PAGE_ROUTE = '/new/settings/';
export const ACCOUNT_CREATE_PAGE_ROUTE = '/new/account/create/';
export const ACCOUNT_CONTROL_PAGE_ROUTE = '/new/accounts/control/';
export const TOP_UP_PAGE_ROUTE = '/new/balance-and-bonuses/';
export const VACANCIES_LINK =
    'https://hh.ru/employer/vacancies?utm_source=clickme.hh.ru&utm_medium=referral&utm_content=upper_menu';
export const MODERATION_REASONS_LIST_PAGE_ROUTE = '/new/admin/moderation-reasons-list/';
export const MULTI_CREATION_ROUTE = '/new/multicreation/auction/';
export const HELP_PAGE_URL = 'https://feedback.hh.ru/?category=clickme';
export const HELP_PAGE_BONUSES = 'https://hh.ru/article/34010';
export const HELP_PAGE_REGION_LIFEHACK_URL = 'https://feedback.hh.ru/knowledge-base/article/0037';
export const HELP_PAGE_RULES_URL = 'https://feedback.hh.ru/?category=clickme&secondaryCategoryId=148';
export const RBK_LINK = 'https://www.rbc.ru/business/01/09/2022/630f23269a7947418b01839d';
export const HELP_MAIL_LINK = 'https://feedback.hh.ru/ticket/add';
export const HELP_PAGE_RECOMMENDATIONS_URL = 'https://hhcdn.ru/file/16979025.pdf';

export const FOOTER_HIDE_ROUTES = [MULTI_CREATION_ROUTE, AUCTION_PAGE_ROUTE];

export const FROM_HH = 'HH';
export const MIN_BALANCE = 0;
export const TEST_STAND_COOKIE_NAME = 'hh_test_stand';
